import { useQuery } from 'react-query'
import { postHelpQuestionQuery } from '../api/helpPanelQueries'
import { PostHelpQuestionResponse } from '../api/helpPanel'

export function usePostHelpQuestionHook(query: string) {
  return useQuery<PostHelpQuestionResponse, Error>({
    ...postHelpQuestionQuery(query),
    enabled: query.length > 0
  })
}
